import { Error, Field, Validator, Value } from '../types/GenericFormTypes';
import { getFieldValue } from './getFieldValue';

export const validate = (
  validators: Validator[],
  values: Value[],
  fields: readonly Field[]
) => {
  const fieldValidators = fields.map((f) =>
    f.validate
      ? () => {
          const e = f.validate(getFieldValue(values, f.id)?.value);

          if (e) {
            return [
              {
                message: e,
                code: e,
                field: f.id,
                type: 'error'
              } as Error
            ];
          }
        }
      : undefined
  );

  const fieldWarners = fields.map((f) =>
    f.warn
      ? () => {
          const e = f.warn(getFieldValue(values, f.id)?.value);
          if (e) {
            return [
              {
                message: e,
                code: e,
                field: f.id,
                type: 'warning'
              } as Error
            ];
          }
        }
      : undefined
  );

  const allValidators = [
    ...validators,
    ...fieldValidators,
    ...fieldWarners
  ].filter(Boolean) as Validator[];

  const allErrors: Error[] = allValidators.reduce((errors, validator) => {
    const e = validator(values, fields);

    return e ? [...errors, ...e] : errors;
  }, []);

  const errors = allErrors.filter((e) => e.type === 'error');
  const warnings = allErrors.filter((e) => e.type === 'warning');

  return {
    errors: errors.length ? errors : undefined,
    warnings: warnings.length ? warnings : undefined
  };
};
